
const routes = [
    {
        name: 'home',
        path: '/',
        component: () => import('../components/Home')
    },
    {
        name: 'contact',
        path: '/contact',
        component: () => import('../components/Contact')
    },
    {
        name: 'services',
        path: '/services',
        component: () => import('../components/Services')
    }
];

export default routes